<template>
	<div>
        <section class="content-header">
            <div class="container-fluid">
                <div class="row">
                    <div class="col-md-6">
                        <h3>{{ $t('label.application') }}</h3>
                    </div>
                    <div class="col-md-6">
                        <ol class="breadcrumb float-sm-right">
                            <li class="breadcrumb-item"><router-link to="/">{{ $t("label.home")}}</router-link></li>
                            <li class="breadcrumb-item"><router-link to="/application">{{ $t("label.application")}}</router-link></li>
                            <li class="breadcrumb-item active">{{ $t("label.list")}}</li>
                        </ol>
                    </div>
                </div>
            </div>
        </section>
        <div class="content">
            <div class="container-fluid">
				<div class="card card-success card-outline">
					<div class="card-header px-2">
						<h3 class="card-title">{{ $t("label.application")}}</h3>
						<div class="card-tools">
<!--							<button type="button" class="btn btn-tool" data-widget="collapse" :title="$t('label.collapse')" @click="collapse.search = !collapse.search">-->
<!--								<fa :icon="collapse.search ? fas.faAngleLeft : fas.faAngleDown" style="font-size: 20px"/>-->
<!--							</button>-->
						</div>
					</div>
					<div class="card-body">
						<div class="row">
							<label class="col-form-label">{{$t('label.from_date')}}</label>
							<div class="form-group col-md-3">
								<datepicker @input="clearToDate" :bootstrapStyling="true" :clearButton="true" v-validate="'required'" input-class="form-control form-control-datepicker"  format="dd-MM-yyyy" v-model="search.from_date" name="from_date">
								</datepicker>
								<span v-if="errors.has('from_date')" class="text-danger">{{ errors.first('from_date')}}</span>
							</div>
							<label class="col-form-label">{{$t('label.to_date')}}</label>
							<div class="form-group col-md-3">
								<datepicker :bootstrapStyling="true" :clearButton="true" v-validate="'required'" input-class="form-control form-control-datepicker"  format="dd-MM-yyyy" v-model="search.to_date" name="to_date" :disabledDates="{to:new Date(search.from_date)}">
								</datepicker>
								<span v-if="errors.has('to_date')" class="text-danger">{{ errors.first('to_date')}}</span>
							</div>
							<div class="form-group col-md-2">
								<button type="button" class="btn btn-sm btn-primary" @click.prevent="getApplications(pageNumber, 'registration_date', order_type, true, false)"><fa :icon="fas.faSearch" class="left fa fa-circle-o nav-icon" />{{ $t('label.search') }}</button>
							</div>
						</div>
						<div class="table-responsive" v-if="applications.length > 0">
							<table class="table table-bordered mb-0">
								<thead>
									<tr class="cursor-pointer">
										<th nowrap style="width: 1%;"></th>
										<th nowrap @click="getApplications(1, 'lodgement_office_code', order_type)">{{$t('label.lodgement_office_name')}}</th>
										<th nowrap @click="getApplications(1, 'registration_type', order_type)">{{$t('label.type')}}</th>
										<th nowrap @click="getApplications(1, 'registration_date', order_type)">{{$t('label.register_date')}}</th>
										<th nowrap @click="getApplications(1, 'registration_number', order_type)">{{$t('label.register_number')}}</th>
										<th nowrap @click="getApplications(1, 'lodgement_office_date', order_type)">{{$t('label.lodgement_office_date')}}</th>
										<th nowrap @click="getApplications(1, 'destination_office_code', order_type)">{{$t('label.destination_office_code')}}</th>
										<th nowrap @click="getApplications(1, 'destination_office_date', order_type)">{{$t('label.destination_office_date')}}</th>
										<th nowrap style="width: 1%;"></th>
									</tr>
								</thead>
								<tbody  >
									<tr v-for="(app, index) in applications" :key="index" :value="app.code" :style="'background-color: ' + getColor(app)">
										<td>{{index+1}}</td>
										<td>{{app.lodgement_office_code}}</td>
										<td>{{app.registration_type}}</td>
										<td>{{app.registration_date}}</td>
										<td>{{app.registration_year}} {{app.registration_serial}} {{app.registration_number}}</td>
										<td>{{app.lodgement_office_date}}</td>
										<td>{{app.destination_office_code}}</td>
										<td>{{app.destination_office_date}}</td>
										<td nowrap style="width: 1%; text-align:center;">
											<router-link v-if="getPermission('tempvehicle.application.view')" :to="{ name:'ViewApplication', params:{ uuid: app.uuid }}" :title="$t('label.view')" class="mr-2"><fa :icon="fas.faEye"/></router-link>
											<router-link v-if="getPermission('tempvehicle.application.edit') && isEditable(app)" :to="{ name:'EditApplication', params:{ uuid: app.uuid }}" :title="$t('label.edit')"><fa :icon="fas.faEdit" style="color: green;"/></router-link>
										</td>
									</tr>
								</tbody>
							</table>
						</div>
						<div class="callout callout-success" v-if="applications.length == 0 && search_click == true">
							<label>{{$t('label.no_data')}}</label>
						</div>
						<div class="callout callout-success" v-if="applications.length == 0 && search_click == false">
							<label>{{$t('label.no_application')}}</label>
						</div>
					</div>	
					<div class="card-footer">
						<paginate class="mb-0"
							:page-count="last_page"
							:page-range="3"
							:margin-pages="2"
							:click-handler="getApplications"
							:container-class="'pagination float-right'"
							:prev-text="'Prev'"
							:next-text="'Next'"
							:page-class="'page-item'"
							:active-class="'active'"
							:prev-link-class="'page-link'"
							:force-page="forcepage"
							:next-link-class="'page-link'"
							:page-link-class="'page-link'">
						</paginate>
					</div>
				</div>
            </div>
        </div>
    </div>
</template>

<script>

import { fas } from "@fortawesome/free-solid-svg-icons";
export default {
	name: 'ApplicationList',
	data() {
		return {
			search_click: false,
			year : (new Date()).getFullYear(),
			search: {
				from_date: new Date(),
				to_date: new Date()
			},			
			baseURI: "",
			uuid: '',
			applications:[],
			forcepage:1,
			pageNumber:1,
			last_page: 0,
			order_by:'registration_date',
			order_type:'desc',
			order_type_after_sort:'',
			en_routing: false,
			collapse:{
				search: false,
			}
		}
	},
	computed:{
		fas() {
            return fas;
		}
	},
	mounted () {
		this.search.from_date = this.year+'/01/01'; 
		this.getApplications(1, 'registration_date', 'desc', false);
		this.uuid = this.$route.params.app_uuid;
		if(this.$route.query.en_routing){
			this.en_routing = this.$route.query.en_routing;
		}
		$(".vdp-datepicker").find("input").css("background-color", "white");
	},
	methods: {
		validate() {
			this.$validator.validateAll();
			return this.errors.any();
		},
		getApplications(pageNumber, order_by, order_type, myevent, is_search_click){
			this.search_click = myevent;
			this.forcepage = pageNumber;
			this.$validator.validate().then(result => {
				if (result) {
					this.forcepage = pageNumber;
					this.$store.state.loading.status = true;
					(order_by == null ? order_by = this.order_by : order_by);
					(order_type == null ? order_type = this.order_type_after_sort : order_type);
					let url = this.baseURI + 'applications/search?page='+pageNumber+'&order_by='+order_by+'&order_type='+order_type+'&en_routing='+this.en_routing;
					GDCE_Client.requestApi("POST", url, {search:this.search}).then(response => {
						this.applications = response.data.data;
						this.last_page = response.data.last_page;
						this.forcepage = response.data.current_page;
						(order_type === 'desc' ? this.order_type = 'asc' : this.order_type='desc');
						this.order_type_after_sort = order_type;
						this.order_by = order_by;
						this.$store.state.loading.status = false;
					}).catch(error => {
						this.$store.state.loading.status = false;
					});
				}
			});
		},
		getColor(app){
			if(app.destination && app.destination.status === 'Approve'){
				return "#cce5ff";
			}else if(app.destination && app.destination.status === 'Decline'){
				return "#f8d7da";
			}else if(app.lodgement && app.lodgement.status === 'Approve'){
				return "#d4edda";
			}else if(app.lodgement && app.lodgement.status === 'Decline'){
				return "#fff3cd";
			}else {
				return "white";
			}
		},
		clearToDate(data){
			this.search.to_date ='';
		},
		deleteApplication(uuid){
			this.$swal({
				title: this.$t('label.confirm'),
				text: this.$t('label.confirm_delete'),
				icon: "warning",
				buttons: true,
				dangerMode: true
			}).then(willDelete => {
				if (willDelete) {
					let url = this.baseURI + "/backend/applications/" + uuid;
					GDCE_Client.requestApi("DELETE", url).then(response => {
						this.$swal({
							title: this.$t('label.confirm'),
							text: this.$t('label.delete_success'),
							icon: "success",
							buttons: true,
							dangerMode: true
						});
						this.searchApplication(this.pageNumber, null, null);
					});
				}
			});
		},
		getPermission(permission = ''){
            return this.$hasPermission(permission) ? true : false;
    },
    isEditable(app){
		  return !app.lodgement;
      // if(app.lodgement && app.lodgement.status === 'Decline'){
      //   return false;
      // }
		  // return app.destination === null;
    }
	}
}
</script>
